export enum AuditAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  Configure = 'configure',
  ConfigureFailed = 'configureFailed',
  Activate = 'activate',
  Deactivate = 'deactivate',
  ForceVas = 'forceVas',
  Restart = 'restart',
  FactoryReset = 'factoryReset',
  Webhook = 'webhook',
  BatteryTest = 'batteryTest',
  Warning = 'warning',
  Error = 'error',
  Action = 'action',
}
